<div class="delivery-countdown-timer-example" [ngClass]="{ 'is-mobile': isMobile }">
  <div class="shopify-banner" [attr.data-variant]="bannerVariant">
    <div class="shopify-banner__icon">
      <pdq-icon [icon]="bannerIcon"></pdq-icon>
    </div>
    <div class="shopify-banner__content">
      <div class="display-text" [innerHTML]="template | deliveryCountdownTimerDisplayText | safe: 'html'"></div>
    </div>
  </div>
</div>
